if (!customElements.get('adore-customer-stories')) {
  customElements.define('adore-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const dialog = this.querySelector('dialog');
      const image = dialog.querySelector('img');
      const caption = dialog.querySelector('p');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-photo]');
        if (trigger && this.contains(trigger)) {
          this.trigger = trigger;
          image.width = Number(trigger.querySelector('img').getAttribute('width'));
          image.height = Number(trigger.querySelector('img').getAttribute('height'));
          image.src = trigger.dataset.photo;
          image.alt = trigger.dataset.caption;
          caption.textContent = trigger.dataset.caption;
          dialog.showModal();
        }
        if (event.target.closest('.acs-dialog-close')) dialog.close();
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => this.trigger?.focus({preventScroll:true}));
    }
  });
}
